

























































































import { MacAddressRegex } from '@/constants/device-management'

export default {
  data() {
    return {
      gatewayId: '',
      gatewayIdIsValid: false,
      isAttemptingGatewayReboot: false,
      hasAttemptedGatewayReboot: false,
      hasSuccessfulGatewayReboot: false,
      showFailedGatewayRebootSnackbar: false,
      gatewayIdRules: [
        v => !!v || 'Please enter your gateway ID',
        v =>
          MacAddressRegex.test(v) ||
          'Please double check your gateway ID. A valid gateway has 6 pairs of characters separated by colons. For example: 01:23:45:67:89:AB',
      ],
    }
  },
  computed: {
    actionButton() {
      return {
        text: this.hasAttemptedGatewayReboot ? 'Done' : 'Reboot',
        isDisabled: !this.gatewayIdIsValid || this.isAttemptingGatewayReboot,
        action: this.hasAttemptedGatewayReboot ? this.resetStage : this.rebootGateway,
      }
    },
    rebootAttemptOutcome() {
      return {
        icon: this.hasSuccessfulGatewayReboot ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline',
        iconColor: this.hasSuccessfulGatewayReboot ? 'green' : 'red',
        text: this.hasSuccessfulGatewayReboot
          ? 'has been successfully rebooted'
          : 'failed to connect. Please try again',
        showTryAgainAction: !this.hasSuccessfulGatewayReboot,
      }
    },
  },

  methods: {
    async rebootGateway() {
      try {
        console.info('this function will attempt to reboot the gateway')
        this.closeFailedGatewayRebootSnackbar()
        this.isAttemptingGatewayReboot = true
        setTimeout(() => {
          this.isAttemptingGatewayReboot = false
          this.hasAttemptedGatewayReboot = true
          this.hasSuccessfulGatewayReboot = true

          //this.hasSuccessfulGatewayReboot = false;
          //this.showFailedGatewayRebootSnackbar = true;
        }, 2000)
      } catch (err) {
        console.log(err)
      }
    },
    resetStage() {
      this.hasAttemptedGatewayReboot = false
      this.hasSuccessfulGatewayReboot = false
      this.closeFailedGatewayRebootSnackbar()
      this.$nextTick(() => {
        this.$refs.rebootGatewayForm.reset()
      })
    },
    closeFailedGatewayRebootSnackbar() {
      this.showFailedGatewayRebootSnackbar = false
    },
  },
}
